"use client";

import { createContext, useContext } from "react";

export type PageLocalization = {
  locale: string; // "en" | "de" | ...
  alias?: string | null;
  slug?: string | null; // present in Strapi v5 but we use alias for URL
};

export type I18nPageInfo = {
  alias: string;
  currentLocale: string; // e.g. "en"
  defaultLocale?: string; // e.g. "en"
  localizations?: PageLocalization[];
};

const I18nContext = createContext<I18nPageInfo | null>(null);

export function I18nProvider({
  value,
  children,
}: {
  value: I18nPageInfo;
  children: React.ReactNode;
}) {
  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
}

export function useI18nPageInfo() {
  return useContext(I18nContext);
}
